module.exports = __webpack_public_path__ + "static/img/2126_phase_function_Paper_Points.d9a334b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2126_phase_function_Paper_Points.png
// module id = K8hz
// module chunks = 0